import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { PlanDefinition, BillingCycle } from 'src/app/core/models/subscription.model';

@Component({
  selector:    'app-landing',
  templateUrl: './landing.component.html',
  styleUrls:   ['./landing.component.css']
})
export class LandingComponent implements OnInit, OnDestroy {

  scrolled   = false;
  mobileOpen = false;
  year       = new Date().getFullYear();

  // ── Pricing (same source as the pricing page) ──
  plans:        PlanDefinition[] = [];
  billingCycle: BillingCycle     = BillingCycle.Monthly;
  BillingCycle  = BillingCycle;
  plansLoading  = true;

  constructor(private subscriptionService: SubscriptionService) {}

  ngOnInit(): void {
    this.loadPlans();
  }

  ngOnDestroy(): void {}

  @HostListener('window:scroll')
  onScroll(): void {
    this.scrolled = window.scrollY > 48;
    if (this.mobileOpen) this.mobileOpen = false;
  }

  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  loadPlans(): void {
    this.plansLoading = true;
    this.subscriptionService.getPlans().subscribe({
      next: (plans) => {
        // Landing page shows ALL plans, including Free (unlike /pricing which hides it)
        this.plans = plans;
        this.plansLoading = false;
      },
      error: () => { this.plansLoading = false; }
    });
  }

  toggleBilling(): void {
    this.billingCycle = this.billingCycle === BillingCycle.Monthly
      ? BillingCycle.Annual
      : BillingCycle.Monthly;
  }

  getMonthlyEquivalent(plan: PlanDefinition): number {
    return this.billingCycle === BillingCycle.Annual
      ? Math.round(plan.priceAnnual / 12)
      : plan.priceMonthly;
  }

  isPopular(planName: string): boolean {
    return planName === 'Professional';
  }

  isFree(planName: string): boolean {
    return planName === 'Free';
  }
}